// Use environment variable if available, otherwise default to localhost
const API_BASE_URL = process.env.REACT_APP_API_URL;

console.log("API Base URL:", API_BASE_URL);

// Check if API_BASE_URL is properly configured
if (!API_BASE_URL) {
  console.error(
    "API_BASE_URL is not defined! This could cause API requests to fail."
  );
}

export async function fetchWithAuth(
  endpoint: string,
  options: RequestInit = {}
) {
  const token = localStorage.getItem("authToken");

  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  console.log(`Making authenticated request to: ${API_BASE_URL}${endpoint}`);

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers,
    });

    console.log(`Response status from ${endpoint}: ${response.status}`);

    // Handle response based on content type
    const contentType = response.headers.get("content-type");
    let data;

    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      // For non-JSON responses, just get the text
      const text = await response.text();
      data = { message: text };
    }

    // If the response indicates an authentication error, clear the token
    if (!response.ok && (response.status === 401 || response.status === 403)) {
      localStorage.removeItem("authToken");
      // Redirect to login if not already there
      if (!window.location.pathname.includes("/auth/sign-in")) {
        window.location.href = "/auth/sign-in";
      }
      throw new Error(data.message || "Authentication failed");
    }

    if (!response.ok) {
      console.error(`API Error (${endpoint}): ${response.status}`, data);
      throw new Error(data.message || "API request failed");
    }

    return data;
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    throw error;
  }
}

export const BASE_API_URL = API_BASE_URL;
